import OrderJoinRequest, { OrderJoinRequestBody } from "./order-join.request";

const createBody = (request: OrderJoinRequest): OrderJoinRequestBody => {
  return {
    dryRun: request.dryRun,
    sourceOrderIds: request.sourceOrderIds,
    targetOrderUuid: request.targetOrderUuid,
  };
};

const orderJoinRequestFactory = {
  createBody,
};

export default orderJoinRequestFactory;
